import React from 'react'
import {format} from 'date-fns'


export const cinfoSchedule = (action, date_format = 'dd-MM-yyyy', props = null) => {
	const evt_start = action.evt_start instanceof Date ? format(action.evt_start, date_format) : action.evt_start;
	const evt_end = action.evt_end instanceof Date ? format(action.evt_end, date_format) : action.evt_end;

	return evt_start && <small title='periodo' {...props}> [{evt_start}{evt_end && evt_end != evt_start ? (' a ' + evt_end) : null}]</small>;
}

export const cinfo = (action) => {
	const typology = !action.program ? null : <span title='Programa/Tipologia'> - {action.program}</span>;
	const sep = '»';
	const course_info = action.course_code
		? [
			<small key='c' title='candidatura'>{action.can_number}</small>,
			<small key='k' title='cód. curso'> {sep} {action.course_code}</small>,
			<small key='a' title='n.º ação'> {sep} {action.action_number}</small>
		]
		: null;

	return (
		<div>
			<div>
				{action.id === undefined || action.id <= 0 ? <em className='la la-graduation-cap' title="formação externa" /> : null}
				{action.courseaction_ref ? <span title='referência da ação'>[{action.courseaction_ref}] </span> : null}
				<span id={action.id} title='nome do curso'>{action.course}</span>
				{typology}
			</div>
			{course_info} {sep} {cinfoSchedule(action)}
			{action.local && <small title='local'> {sep} {action.local}</small>}
			{action.duration_effect && <small title='n.º horas'> {sep} ({action.duration_effect} horas)</small>}
			{action.web_schedule && <div><small title='horário'>{action.web_schedule}</small></div>}
			{action.training_entity && <div><small title='entidade'> {sep} {action.training_entity}</small></div>}
		</div>
	);
}

export default class CourseInfo extends React.Component {
	render() {
		if (!this.props.courseaction) {
			return null;
		}
		const courseaction = this.props.courseaction;

		return (
			<div className="form-group row clear courseinfo">
				<div className="col-xs-12">
					{cinfo(courseaction)}
				</div>
			</div>
		);
	}
}
